import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { getListMarca } from "../api/api-marca";

export default function ModalFormModelo({ title, formData, setFormData, isOpen, onCancel, onConfirm }) {

    const { t } = useTranslation();
    const [listMarca, setListMarca] = useState([]);
    const [marcaSelected, setMarcaSelected] = useState(null);

    useEffect(() => {
        iniciar();
    }, [formData]);

    const iniciar = async () => {
        try {
            // console.log('formData');
            // console.log(formData);
            const listaMarca = await getListMarca({ habilitado: 1 }, true, t);
            // console.log('listaMarca');
            // console.log(listaMarca);
            setListMarca(listaMarca);
            if (formData.idMarca === null) {
                setMarcaSelected(null);
            }
            if (formData.idMarca !== undefined && formData.idMarca !== null && String(formData.idMarca).length > 0) {
                const marca = listaMarca.find(e => e.value === formData.idMarca);
                // console.log('marca');
                // console.log(marca);
                setMarcaSelected(marca);
            }
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
        }
    };

    const charLimits = {
        codigo: 32,
        descripcion: 32,
        nota: 128,
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (value.length <= charLimits[name]) {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const validateForm = () => {
        try {
            // console.log('validateForm');
            let message = "";
            if (String(formData.descripcion).trim().length === 0) {
                message = message + "Debe ingresar descripcion" + '\n';
            }
            if (message.length > 0) {
                alert(message);
                return;
            }
            onConfirm(formData);
        } catch (err) {
            console.log('validateForm err');
            console.log(err);
        }
    };

    const cancelForm = () => {
        setFormData({
            ...formData,
            codigo: "",
            descripcion: "",
            nota: "",
        });
        setMarcaSelected(null);
        onCancel();
    }

    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
                        <h2 className="text-xl font-bold mb-4 text-gray-700">{title}</h2>
                        {/* MARCA */}
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("label_brand")}<span className="text-red-500">*</span></label>
                            <Select
                                options={listMarca}
                                isSearchable={true}
                                isClearable={true}
                                value={marcaSelected}
                                onChange={(event) => {
                                    setMarcaSelected(event);
                                    if (event === null) {
                                        formData.idMarca = null;
                                    }
                                    if (event !== null) {
                                        formData.idMarca = event.value;
                                    }
                                }}
                                placeholder={t("label_select_marca")}
                                className="w-full"
                                menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                            />
                        </div>
                        {/* Inputs */}
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("code")}</label>
                            <input
                                name="codigo"
                                value={formData.codigo}
                                onChange={handleInputChange}
                                placeholder={t("enter_code")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.codigo.length}/{charLimits.codigo}</p>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("description")}<span className="text-red-500">*</span></label>
                            <input
                                name="descripcion"
                                value={formData.descripcion}
                                onChange={handleInputChange}
                                placeholder={t("enter_description")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.descripcion.length}/{charLimits.descripcion}</p>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("note")}</label>
                            <input
                                name="nota"
                                value={formData.nota}
                                onChange={handleInputChange}
                                placeholder={t("enter_note")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.nota.length}/{charLimits.nota}</p>
                        </div>

                        {/* Buttons */}
                        <div className="flex justify-end gap-4">
                            <button
                                onClick={cancelForm}
                                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500 transition duration-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={validateForm}
                                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition duration-300"
                            >
                                Acceptar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );

}
